module.exports = {
  "id": "stone-floor",
  "title": "stone floor",
  "image": "provision/parts/stone-floor/stone-floor.png",
  "info": [
    {
      "text": "Add a stone platform to your project",
      "image": "provision/parts/stone-floor/stone-floor.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/stone-floor/stone-floor.png"
} ;